import { Component, OnInit,Input } from '@angular/core';
import { TicketsService,ManufacturerService,ModelService,PartsService,FavoriteService,MessageService } from 'src/app/services';
import {SelectItem} from 'primeng/api'; 
import { AccessUserInfo } from 'src/app/models';
@Component({
  selector: 'bart-parts-search',
  templateUrl: './parts-search.component.html',
  styleUrls: ['./parts-search.component.scss']
})
export class PartsSearchComponent implements OnInit {
  //var partFavoriteListTypeId = 1;
  first: number = 0;
  public totalRecords = 0;
  userID:number=0;
  userDetail :any  =null;
  ManuFacturerListData: SelectItem[];
  modelsList: SelectItem[];
  getVendorsParam = {
    isActiveFlag:1
  }
  getModelsParam = {
    iProcVendorID : 0,
    showModels:1
  };

  public selectedFavListItemValue:number=null;
  public displayFavModal:boolean=false;
  public favoritesPartNumber:number=null;
  public favoriteListName:string = null;
  public favoritesPartId:number=null;
  public favoritesDescription:number=null;
  public selectedFavListValue:SelectItem;
  public favListData:any[]=[];  //for grid
  public favListParts:SelectItem[]=[];// for dropdown
  public allFavList:any[]=[];//for filter
  public disableSave:boolean = false;
  public alreadyExistMsg:string = "";
  public hideAlreadyExist:boolean=true;
  public hideSaved:boolean=true;
  public SavedMsg:string = "";
  public hideAddFavoritContent:boolean = false;
  
  
  errors :any[];
  dialogHeader:string;
  ShowAlertpopup:boolean;
  SearchPartsColumns:any;
  SearchPartsResult:any[];
  partSrch: partsSearch | undefined;
  ShowLodingGrid = false;
  //modelId :0,
  searchPartsParam={
    iProcVendorId:0, 
    searchTerm:'',
    orderBy:'pp.partId desc',
    manufacturerId:0,
    modelIdList:null,
    allParts:0,
    isAdhocFlag:0,
    isModelPartSearch:0,
    isGrid:1
  }
  getFavoriteListPartsParam={
    favoriteListId : 0, 
    favoriteListTypeId : 0,  
    favoriteListPartId : 0, 
    sortColumn :null,  
    activePart : 0,  
    userId : 0  
  }

   getFavoriteListParam= {
    favoriteListTypeId:1,   
    userId:0,
    maxCount:10,
    favoriteListName:null,
    favoriteListId:null ,  
    Check :0
}
  constructor(private _TicketsService:TicketsService,private _ManufacturerService:ManufacturerService,private _ModelService:ModelService,private _PartsService:PartsService , 
    private _favoriteService:FavoriteService,private _messageService:MessageService)
   { 
    this.partSrch={manufacturerId:0,modelId:0,searchTerm:''};
    this.userDetail = AccessUserInfo.getUserInfo();
    if(this.userDetail !=null)
    {
      this.userID = this.userDetail.userId;
    }
   }

  ngOnInit() {
    this.ShowAlertpopup=false;
    this.SearchPartsColumns=[
      { field: 'partId', header: 'PartID',display: 'none'  },
      { field: 'partNumber', header: 'Part #' ,display: 'table-cell'},
      { field: 'partDescription', header: 'Description',display: 'table-cell' },
      { field: 'unitPrice', header: 'Price' ,display: 'table-cell',textAlign:'right'},
      { field: 'partOriginValue', header: 'Part Info' ,display: 'table-cell'},
      { field: 'manufacturerName', header: 'Vendor',display: 'table-cell' },
      { field: 'mfgPartNumber', header: 'Mfg. Part #' ,display: 'table-cell'},
      { field: 'bestValue', header: 'Best Value',display: 'table-cell' },
      
    ]

  //this.dashTickets();
  this.getManufacturers(this.getVendorsParam);
  this.loadFavoritePartsList();
   this.LoadModels(0);
  }
 
  public searchParts(SEARCHPARTS:any) {

    this.SearchPartsResult=[];
    if (SEARCHPARTS != null) {
      this.ShowLodingGrid = true;
      this._PartsService.searchParts( JSON.stringify({SEARCHPARTS}))
      .subscribe((searchPartsResponse: any) => {
        if(searchPartsResponse.parts.length> 0)
        {
          this.SearchPartsResult = searchPartsResponse.parts;          
        }
        this.ShowLodingGrid = false;
       
        }
        , (respose: Response) => {
          this.SearchPartsResult = [];
          this.ShowLodingGrid = false;
          // handle error here
        }
      );
    }
  }

  searchPart()
  {
     this.searchPartsParam.iProcVendorId = this.partSrch.manufacturerId;
     this.searchPartsParam.searchTerm = this.partSrch.searchTerm;
     this.searchPartsParam.modelIdList= this.partSrch.modelId;
     this.searchPartsParam.isModelPartSearch=this.partSrch.modelId>0?1:0
     this.searchParts(this.searchPartsParam);
  }

  public getManufacturers(GETVENDORS:any) {
    if (GETVENDORS != null) {
      this._ManufacturerService.getVendors(JSON.stringify({GETVENDORS}))
      .subscribe((getVendorsParamResponse: any) => {
        if(getVendorsParamResponse.manufacturers.length> 0)
        {
          this.ManuFacturerListData = [];
          //this.ManuFacturerListData = getVendorsParamResponse.manufacturers;
          for (let c of getVendorsParamResponse.manufacturers) {
            if(c.IProcVendorId >0)
            {
            this.ManuFacturerListData.push({ label:c.ManufacturerName,value:c.IProcVendorId});
            }
            }
        }
        
        }, (respose: Response) => {
          this.ManuFacturerListData = [];
        
        }
       
       
      );
    }

}

LoadModels(value)
{
  this.modelsList = [];
  if (this.partSrch.manufacturerId != null) 
  {
      this.getModelsParam.iProcVendorID = this.partSrch.manufacturerId;
      this.getModels(this.getModelsParam);
  }
  else
  {
    this.getModelsParam.iProcVendorID=0
    this.getModels(this.getModelsParam);
  }

}

public getModels(GETVENDORINFO:any) {
  var GETVENDORINFO = GETVENDORINFO;
  if (GETVENDORINFO != null) {
    this._ManufacturerService.getVendorInfo(JSON.stringify({GETVENDORINFO}))
    .subscribe((allModelsResponse: any) => {
      if(allModelsResponse.records.length> 0)
      {
        this.modelsList = [];
        // handle error here
        for (let c of allModelsResponse.records) 
        {
         // this.modelsList.push({ label: c.modeldescription, value:c.modelid});
          if(this.modelsList.filter(x=>x.value==c.modelId).length==0)
          {
            this.modelsList.push({ label: c.ModelDescription, value:c.modelId});
          }
        }
      }
    
      }, (respose: Response) => {
        this.modelsList = [];
      }
    );
  }
}


onRowSelect(event) {

 /* this.msgs = [];
  this.msgs.push({severity: 'info', summary: 'Selected', 
  detail:event.data.name + ' - ' + event.data.language});

  */
 this.displayFavModal=true;
 
 this.favoritesPartNumber = event.data.partNumber;
 this.favoritesDescription = event.data.partDescription;
 this.favoritesPartId =  event.data.partId;
 /*if(rowDetails!=null)
 {
   this.displayFavModal=true;
   this.favoritesEquipmentId=rowDetails["equipmentId"];
   this.favoritesEquipmentSerial=rowDetails["serialNumber"];
 }*/

}


public loadFavoritePartsList()
{
  

  if (this.getFavoriteListParam != null) {
    this.getFavoriteListParam.favoriteListId = null;
    this.getFavoriteListParam.userId = this.userDetail.userId;
    this.getFavoriteListParam.Check =0;
    var GETFAVORITELIST = this.getFavoriteListParam;

    this._favoriteService.getFavoriteList(JSON.stringify({GETFAVORITELIST}))
      .subscribe((response: any) => {
        this.favListParts = [];
        this.favListParts.push({label:'New...',value:0});
       if (response.records.length > 0) {
        
        this.allFavList=response.records
        this.favListData=this.allFavList;
          for (let c of response.records) {
            this.favListParts.push({ label: c.favoriteListName, value:c.favoriteListId});
          }
      }
      }, (error) => {
        this.allFavList=[];
        console.log(error);
      }
      );
  }
}


    addFavoriteListPram={
      favoriteListName :'',
      favoriteListTypeId :0,   
      userId: 0  

    }
    addFavoriteListParttPram=
    {
      partId:0,
      favoriteListId:0

    }

SaveFavorites()
{
  var favoriteListId = null;
  if(this.selectedFavListValue != undefined)
  {
    var favoriteListId = this.selectedFavListValue.value;
  }
  var partId = this.favoritesPartId;
  var msg = "";
  var favListName = "";
  var nameExists = "";
  favListName = this.favoriteListName;
  
  if (favoriteListId == null ||favoriteListId == undefined  ) {
    this._messageService.showAlertMessage("Please choose a list")
    //alert("Please choose a list");
    return false;
  }
  /*if (favoriteListId ==0 ) {
    favListName = this.favoriteListName;
  }*/
    
    if ((favListName == "" || favListName ==null)&&this.selectedFavListValue.value <=0) {
      //alert("Please enter a name for the list");
      this._messageService.showAlertMessage("Please enter a name for the list")
      return false;
    }
    
    //nameExists = psp_checkListName(favListName);
    
    /*if (nameExists) {
      alert("A list with that name already exists");
      return false;	
    }*/

    //********************************************************************************************************************** */
     //psp_checkListName
    /* var proxyParams = {
			object:'favObj',
			method:'getFavoriteList',
			favoriteListName:favListName,
			favoriteListTypeId:partFavoriteListTypeId,
			check:1
		};*/
   
    if (this.getFavoriteListParam != null) {

      this.getFavoriteListParam.favoriteListId = favoriteListId;
      this.getFavoriteListParam.favoriteListName = this.favoriteListName;
      this.getFavoriteListParam.favoriteListTypeId=1;
      this.getFavoriteListParam.userId =this.userID; 
      this.getFavoriteListParam.Check =1;
      //this.getFavoriteListParam.maxCount=1;
     var  GETFAVORITELIST = this.getFavoriteListParam;
      this._favoriteService.getFavoriteList(JSON.stringify({GETFAVORITELIST})  )
      .subscribe((getFavoriteListResponse: any) => {
        if(getFavoriteListResponse.records.length> 0 && favoriteListId==0)
        {
          // Check Favlist name already exist
          //alert("A list with that name already exists");
          this._messageService.showAlertMessage("A list with that name already exists")
        }
        else
        {
          // add favorite List name (add new part list name and new part)
          //***************************************************************** */
          //if(getFavoriteListResponse.records.length<= 0 && favoriteListId==0)//Changed By Harikesh on 10-Oct-2020 for Defect#12237
          if(favoriteListId==0)
          {
            
                      this.addFavoriteListPram.favoriteListName = this.favoriteListName;
                      this.addFavoriteListPram.favoriteListTypeId=1;
                      this.addFavoriteListPram.userId =this.userID;
                      var  ADDFAVORITELIST = this.addFavoriteListPram;
                      var GETFAVORITELIST = this.addFavoriteListPram ;
                      if (GETFAVORITELIST!= null) {
                        this._favoriteService.addFavoriteList(JSON.stringify({GETFAVORITELIST,ADDFAVORITELIST}) )
                        .subscribe((addFavoriteListResponse: any) => {
                          if(addFavoriteListResponse.records.length> 0)
                          {
                                      //Adding Favorite List Part
                                    //************************** */
                                    this.addFavoriteListParttPram.favoriteListId = addFavoriteListResponse.records[0].favoriteListId;
                                    this.addFavoriteListParttPram.partId = partId;
                                      var ADDFAVORITELISTPART = this.addFavoriteListParttPram;
                                    if (ADDFAVORITELISTPART != null) {
                                      this._favoriteService.addFavoriteListPart(JSON.stringify({ADDFAVORITELISTPART}) )
                                      .subscribe((addFavoriteListPartResponse: any) => {
                                        if(addFavoriteListPartResponse.addRecord.length> 0)
                                        {
                                          //Adding Favorite List sucess
                                        //************************** */
                                         // alert('Part Saved to' +' '+ favListName) ;
                                        //msg = "<img src=\"images/checked.png\"> Part Saved to '<em>" + favListName + "</em>' List.";
                                        this.hideAddFavoritContent = true;
                                        this.hideSaved = false;
                                        this.hideAlreadyExist = true;
                                        if (this.selectedFavListValue.value <=0) 
                                        {
                                          this.SavedMsg = "Part Saved to "+ "<i>'"+favListName+"'</i>&nbsp; List.";
                                        }
                                        else
                                        {
                                          this.SavedMsg = "Part Saved to "+ "<i>'"+this.selectedFavListValue.label+"'</i>&nbsp; List.";
                                        }
                                       
                                        //this.loadFavoritePartsList();

                                        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
                                        if (this.getFavoriteListParam != null) {
                                          this.getFavoriteListParam.favoriteListId = null;
                                          this.getFavoriteListParam.favoriteListName = "";
                                          this.getFavoriteListParam.Check =0;
                                          this.getFavoriteListParam.userId = this.userDetail.userId;
                                          var GETFAVORITELIST = this.getFavoriteListParam;
                                      
                                          this._favoriteService.getFavoriteList(JSON.stringify({GETFAVORITELIST}))
                                            .subscribe((response: any) => {
                                              this.favListParts = [];
                                              this.favListParts.push({label:'New...',value:0});
                                             if (response.records.length > 0) {
                                              
                                              this.allFavList=response.records
                                              this.favListData=this.allFavList;
                                      
                                             
                                                for (let c of response.records) {
                                                  this.favListParts.push({ label: c.favoriteListName, value:c.favoriteListId});
                                                }
                                      
                                                
                                            }
                                            }, (error) => {
                                              this.allFavList=[];
                                              console.log(error);
                                            }
                                            );
                                        }
                                        //&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&


                      
                                        //********************************** */
                                        
                                        }
                                      
                                        }, (respose: Response) => {
                                          this.modelsList = [];
                                        }
                                      );
                                    }

                                    //********************************** */
                          
                          }
                        
                          }, (respose: Response) => {
                            this.modelsList = [];
                          }
                        );
                      }
            }



             // add favorite List name already exist then add new part
          //***************************************************************** */
          //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          //if(getFavoriteListResponse.records.length> 0 && favoriteListId>0)//Changed By Harikesh on 10-Oct-2020 for Defect#12237
          if(favoriteListId>0)
          {
            
                       //Adding Favorite List Part
                                    //************************** */
                                    this.addFavoriteListParttPram.favoriteListId = favoriteListId;
                                    this.addFavoriteListParttPram.partId = partId;
                                    if (this.addFavoriteListParttPram != null) {
                                      var ADDFAVORITELISTPART = this.addFavoriteListParttPram;

                                      this._favoriteService.addFavoriteListPart(JSON.stringify({ADDFAVORITELISTPART}))
                                      .subscribe((addFavoriteListPartResponse: any) => {
                                        if(addFavoriteListPartResponse.addRecord.length> 0)
                                        {
                                          //Adding Favorite List sucess
                                        //************************** */
                                         // alert('Part Saved to' +' '+ favListName) ;
                                        //msg = "<img src=\"images/checked.png\"> Part Saved to '<em>" + favListName + "</em>' List.";
                                        this.hideAddFavoritContent = true;
                                        this.hideSaved = false;
                                        this.hideAlreadyExist = true;
                                        //this.SavedMsg = 'Part Saved to' +' '+ this.selectedFavListValue.label;
                                        this.SavedMsg = "Part Saved to "+ "<i>'"+this.selectedFavListValue.label+"'</i>&nbsp; List.";
                                        this.loadFavoritePartsList();
                      
                                        //********************************** */
                                        
                                        }
                                      
                                        }, (respose: Response) => {
                                          this.modelsList = [];
                                        }
                                      );
                                    }

                                    //********************************** */
                    
            }
            //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
          //************************************************************************* */


        }





      
        }, (respose: Response) => {
          this.modelsList = [];
        }
      );
    }
    //*********************************************************************************************************************** */

    /*
    var proxyParams = {
      object:'favObj',
      method:'addFavoriteList',
      favoriteListName:favListName,
      favoriteListTypeId:partFavoriteListTypeId
    };
    
    $.ajax({data:proxyParams,success:function(favoriteData){
      favoriteListId = favoriteData.records.data.favoritelistid[0];
    }});
  } else {
    favListName = $(psp_favoriteListObj + " option:selected").text();
  }*/

}

cancelFavoriteList()
{
  this.hideAlreadyExist= true;
  this.hideSaved = true
  this.hideAddFavoritContent = false;
  if(this.selectedFavListValue !=undefined)
  {
    this.selectedFavListValue.value = undefined;
    this.selectedFavListItemValue = null;
 }
 
 this.loadFavoritePartsList();

}
getFavoriteListPart(value)
{

  this.favoriteListName="";
  if(value != null && value.value !=0)
  {
  this.selectedFavListItemValue = this.selectedFavListValue.value;
  this.getFavoriteListPartsParam.favoriteListPartId = this.favoritesPartId;
  this.getFavoriteListPartsParam.favoriteListId =this.selectedFavListValue.value; 
  this.getFavoriteListPartsParam.favoriteListTypeId = 1;

  this.disableSave = true;
  this.hideAlreadyExist = true;

  //check for duplication
  this.getFavoriteListParts(this.getFavoriteListPartsParam,this.selectedFavListValue.label);
  }
  else
  {

    if(value.value==0)
    {
      this.selectedFavListItemValue =0;
      this.disableSave = false;
    }
   
    this.hideAlreadyExist = true;
    this.hideSaved = true;
    //this.disableSave = true;

  }
}

public getFavoriteListParts(getVendorsParam:any,listName:any) {
  if (this.getFavoriteListPartsParam != null) {

    
    var  GETFAVORITELISTPARTS = this.getFavoriteListPartsParam;

    this._favoriteService.getFavoriteListParts(JSON.stringify({GETFAVORITELISTPARTS}) )
    .subscribe((getFavoriteListPartsResponse: any) => 
    {
      if(getFavoriteListPartsResponse.records.length> 0)
      {

        //alert('Part Already Saved to ' + listName +' List.');
       // msg = "<img src=\"images/delete.GIF\"> Part Already Saved to '<em>" + listName + "</em>' List.";
        //psp_showMessage(msg);
        //$('#psp_favoriteSaveBtn').attr("disabfzled",true);
        this.hideAlreadyExist = false;
        this.alreadyExistMsg = 'Part Already Saved to ' + listName +' List.';
        this.disableSave = true;
        
      }
      else
      {
        this.disableSave = false;
        this.hideAlreadyExist = true;

      }
      
    }, (respose: Response) => 
    {
      this.disableSave = false;
      this.hideAlreadyExist = true;
    }
     
     
    );
  }

}

reset() {
  this.first = 0;
}


}
export interface partsSearch {

  manufacturerId :0;
  modelId :0;
	searchTerm :'';
	 
};

